export const webEndPoint = "https://gjjewellery.in/dev_api/api/";